import { lazy } from 'react'
import { Route } from 'react-router-dom'

const Panel = lazy(() => import('../pages/MyPanel'))
const Profile = lazy(() => import('../pages/Profile'))
const Notifications = lazy(() => import('../pages/Notifications'))
const MyPlain = lazy(() => import('../pages/MyPlain'))
const Projects = lazy(() => import('../pages/Projects'))
const CompetitionDetail = lazy(() => import('../pages/CompetitionDetail'))
const MyCompetitionDetail = lazy(() => import('../pages/MyCompetitionsDetails'))
const MyCompetitions = lazy(() => import('../pages/MyCompetitions'))
const WonCompetitions = lazy(() => import('../pages/WonCompetitions'))
const Administrator = lazy(() => import('../pages/Administrator'))
const AdministratorPartner = lazy(() => import('../pages/AdministratorPartner'))
const ChangeLinkView = lazy(() => import('../pages/ChangeLinkView'))
const BudgetLinkPartnerAdm = lazy(() => import('../pages/BudgetLinkPartnerAdm'))
const AdminMarbleResume = lazy(() => import('../pages/MarbleResume'))
const MarbleWorkers = lazy(() => import('../pages/MarbleWorkersList'))
const ProjectsList = lazy(() => import('../pages/ProjectsList'))
const ProjectAdminDetail = lazy(() => import('../pages/CompetitionAdmDetail'))
const RegisterMaterial = lazy(() => import('../pages/RegisterMaterial'))
const RegisterMaterialPartner = lazy(() => import('../pages/RegisterMaterialPartner'))
const CreateBudget = lazy(() => import('../pages/CreateBudget'))
const CreateBudgetPartner = lazy(() => import('../pages/CreateBudgetPartner'))
const CreateUserPartnerLogin = lazy(() => import('../pages/CreateUserPartnerLogin'))
const RegisterParams = lazy(() => import('../pages/RegisterParams'))
const BudgetLinkList = lazy(() => import('../pages/BudgetLinkList'))
const BudgetLinkListPartner = lazy(() => import('../pages/BudgetLinkPartner'))
const UploadFiles = lazy(() => import('../pages/UploadFiles'))
const FlowInstaller = lazy(() => import('../pages/FlowInstaller'))
const FlowPartnerMarble = lazy(() => import('../pages/FlowPartnerMarble'))
const FlowPartnerMeasure = lazy(() => import('../pages/FlowPartnerMeasure'))

const getAllRoutes = ({
    navigate
}) => {
    return [{
        page: 'my_panel',
        component: <Route index path="mypanel" element={<Panel navigate={navigate} />} key="my_panel" />
    },
    {
        page: 'profile',
        component: <Route path="profile" element={<Profile navigate={navigate} />} key="profile" />
    }, {
        page: 'notifications',
        component: <Route path="notifications" element={<Notifications navigate={navigate} />} key="notifications" />
    }, {
        page: 'my_plains',
        component: <Route path="plain" element={<MyPlain navigate={navigate} />} key="my_plains" />
    }, {
        page: 'projects',
        component: <Route path="competitions" element={<Projects navigate={navigate} />} key="projects" />
    }, {
        page: 'competition_detail',
        component: <Route path="competitions/:id" element={<CompetitionDetail navigate={navigate} />} key="competition_detail" />
    }, {
        page: 'my_competition_details',
        component: <Route path="mycompetitions" element={<MyCompetitions navigate={navigate} />} key="my_competition_details" />
    }, {
        page: 'my_competition',
        component: <Route path="mycompetitions/:id" element={<MyCompetitionDetail navigate={navigate} />} key="my_competition" />
    }, {
        page: 'won_competitions',
        component: <Route path="woncompetitions" element={<WonCompetitions navigate={navigate} />} key="won_competitions" />
    },{
        page: 'super_adm',
        component: <Route path="administrator" element={<Administrator navigate={navigate} />} key="administrator" />
    },{
        page: 'adm_marble_resume',
        component: <Route path="administrator/marble/resume/:id" element={<AdminMarbleResume navigate={navigate} />} key="marble_resume" />
    },{
        page: 'adm_marble_list',
        component: <Route path="administrator/marble/users" element={<MarbleWorkers navigate={navigate} />} key="adm_marble_list" />
    },{
        page: 'adm_projects_list',
        component: <Route path="administrator/marble/projects" element={<ProjectsList navigate={navigate} />} key="adm_projects_list" />
  
    },{
        page: 'adm_project_details',
        component: <Route path="administrator/projects/resume/:id" element={<ProjectAdminDetail navigate={navigate} />} key="adm_project_details" />
    },
    {
        page: 'adm_register_materials',
        component: <Route path="register/material" element={<RegisterMaterial navigate={navigate} />} key="adm_register_materials" />
    },
    {
        page: 'adm_budget_materials',
        component: <Route path="budget/create" element={<CreateBudget navigate={navigate} />} key="adm_budget_materials" />
    },
    {
        page: 'adm_budget_parameters',
        component: <Route path="budget/settings" element={<RegisterParams navigate={navigate} />} key="adm_budget_parameters" />
    },
    {
        page: 'adm_budget_list',
        component: <Route path="budget/list" element={<BudgetLinkList navigate={navigate} />} key="adm_budget_list" />
    },
    {
        page: 'super_adm_budget_list',
        component: <Route path="budget/partner/list" element={<BudgetLinkPartnerAdm navigate={navigate} />} key="super_adm_budget_list" />
    },
    {
        page: 'adm_upload_file',
        component: <Route path="content/uploader" element={<UploadFiles navigate={navigate} />} key="adm_upload_file" />
    },
    {
        page: 'adm_materials_partner',
        component: <Route path="partner/materials" element={<RegisterMaterialPartner navigate={navigate} />} key="adm_materials_partner" />
    },
    {
        page: 'adm_budget_partner',
        component: <Route path="partner/budget" element={<CreateBudgetPartner navigate={navigate} />} key="adm_budget_partner" />
    },
    {
        page: 'adm_partner_create',
        component: <Route path="partner/user/creation" element={<CreateUserPartnerLogin navigate={navigate} />} key="adm_partner_create" />
    },
    {
        page: 'adm_budget_list_partner',
        component: <Route path="partner/list" element={<BudgetLinkListPartner navigate={navigate} />} key="adm_budget_list_partner" />
    },
    {
        page: 'super_adm_partner',
        component: <Route path="administrator/partner" element={<AdministratorPartner navigate={navigate} />} key="administrator" />
    },
    {
        page: 'adm_link_layout',
        component: <Route path="change/link" element={<ChangeLinkView navigate={navigate} />} key="administrator" />
    },
    {
        page: 'adm_assembler',
        component: <Route path="flow/installer" element={<FlowInstaller navigate={navigate} />} key="administrator" />
    },
    {
        page: 'adm_marble_flow',
        component: <Route path="flow/marble" element={<FlowPartnerMarble navigate={navigate} />} key="administrator" />
    },
    {
        page: 'adm_measure_flow',
        component: <Route path="flow/measure" element={<FlowPartnerMeasure navigate={navigate} />} key="administrator" />
    },
    {
        page: 'adm_flow_edit',
        component: <Route path="flow/:id/edit/:password" element={<FlowPartnerMeasure navigate={navigate} />} key="administrator" />
    }]
}

export {
    getAllRoutes
}